import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { MessageProvider } from './context/MessageContext';
import { HotspotProvider } from './context/HotspotContext';
import Dashboard from './Dashboard';


// ✅ 修改后的路由守卫：只认名为 "lyywh" 的用户
// const SuperAdminRoute = ({ children }) => {
//   const { user, loading } = useAuth();
//
//   if (loading) return <div className="flex h-screen items-center justify-center">Loading...</div>;
//
//   // 核心修改点：判断用户名是否为 "lyywh"
//   if (!user || user.username !== 'lyywh') {
//     return <Navigate to="/" replace />;
//   }
//
//   return children;
// };

const App = () => {
  return (
    <BrowserRouter>
      <MessageProvider>
        <AuthProvider>
          <HotspotProvider>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              {/* 登录/注册使用弹窗，直接访问这些路径时重定向到首页 */}
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="/register" element={<Navigate to="/" replace />} />
              {/*/!* 管理员路由 *!/*/}
              {/*<Route*/}
              {/*  path="/admin"*/}
              {/*  element={*/}
              {/*    <SuperAdminRoute>*/}
              {/*      <AdminDashboard />*/}
              {/*    </SuperAdminRoute>*/}
              {/*  }*/}
              {/*/>*/}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </HotspotProvider>
        </AuthProvider>
      </MessageProvider>
    </BrowserRouter>
  );
};

export default App;
